module.exports = __webpack_public_path__ + "static/media/levelYosemite.c748cb2b.jpg";